import type { OnboardingAction, OnboardingWizardFormData } from './onboarding-wizard.interface'

const PROMPT_BY_ACTION: Record<OnboardingAction, (url: string) => string> = {
  competition: (url) =>
    `Please analyze competitors of ${url} — who ranks for similar keywords, their backlink profiles, and content strategies.`,
  keywords: (url) =>
    `Please research keyword opportunities for ${url} — find high-potential keywords, search volumes, and content gaps to target.`,
  'seo-state': (url) =>
    `Please perform an SEO audit of ${url} — check technical state with lighthouse, current keyword rankings, and backlinks situation.`,
}

export const generateOnboardingPrompt = (data: OnboardingWizardFormData): string =>
  PROMPT_BY_ACTION[data.action](data.websiteUrl)
